import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  TreeSelect,
} from 'antd'
import { inject, observer } from 'mobx-react'
import validator from '../../validator'
import { FormButtonGroup } from './ReportPageStyled'
import { REPORT_TYPE } from '../../constants'
import SpinnerInlineComponent from '../../components/SpinnerInlineComponent'
import RichEditor from '../../components/RichEditor/RichEditor'
import { blue } from '../../color'
import RuiRoNhanDienTemplate from '../RiskCreatePage/RuiRoNhanDienTemplate'
import utils from '../../utils'
import { handleFilterSelect } from '../../utils/filterSelect'
import moment from 'moment'
import riskAriseStore from '../../stores/riskAriseStore'

const { Option } = Select
const { RangePicker } = DatePicker

const ReportDetailUpdateModal = props => {
  const [form] = Form.useForm()
  const [submitting, setSubmitting] = useState(false)
  const [selectedField, setSelectedField] = useState(null)
  const {
    modalVisible,
    onCancel,
    editReport,
    loadingAnimationStore,
    onRefresh,
    reportStore,
    riskStore,
    companyStore,
    roleStore,
    positionStore,
    departmentStore,
    selectPeopleStore,
    section2Data,
    section3Data,
    selectedRuiRoNhanDienSection2,
    selectedRuiRoNhanDienSection3,
  } = props
  const { departmentWithUserList, getDepartmentWithUsers } = selectPeopleStore
  const { type: reportType, updateRiskReport, reportDetail } = reportStore
  const { riskUnits, riskUnitsV2, getRiskUnits, getRiskUnitsV2 } = riskStore
  const { getCompanyList, companyList } = companyStore
  const { departmentList } = departmentStore

  useEffect(() => {
    ;(async () => {
      try {
        await departmentStore.getDepartmentList()
      } catch (err) {
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      }
    })()
  }, [])

  const arrUnit = riskUnits.concat(companyList)
  const [isRenderRichText, setIsRenderRichText] = useState(false)
  const [unitValue, setUnitValue] = useState([])
  const [unitV2Value, setUnitV2Value] = useState([])
  const [
    isVisibleRuiRoNhanDienTemplate,
    setIsVisibleRuiRoNhanDienTemplate,
  ] = useState(false)
  const [ruiRoNhanDien, setRuiRoNhanDien] = useState({
    section2: selectedRuiRoNhanDienSection2,
    section3: selectedRuiRoNhanDienSection3,
  })
  const [section, setSection] = useState('')
  const SECTION1_REF = useRef()
  const SECTION2_REF = useRef()
  const SECTION3_REF = useRef()
  const SECTION4_REF = useRef()
  const [getData, setGetData] = useState([])
  const [dataRiskUnitsByType, setRiskUnitsByType] = useState([])
  const [dataRiskUnitsByTypeNDDPV, setRiskUnitsByTypeNDDPV] = useState([])
  const getRiskUnitsByTypeList = async type => {
    await riskStore.getRiskUnitsV2(type).then(response => {
      setRiskUnitsByType(response.data)
    })
  }
  const getRiskUnitsByTypeListNDDPV = async type => {
    await riskStore.getRiskUnitsV2(type).then(response => {
      setRiskUnitsByTypeNDDPV(response.data)
    })
  }

  const [ruiRoNhanDienList, setRuiRoNhanDienList] = useState([])

  useEffect(() => {
    setRuiRoNhanDien(prev => ({
      section2:
        prev.section2.length > 0
          ? prev.section2
          : selectedRuiRoNhanDienSection2,
      section3:
        prev.section3.length > 0
          ? prev.section3
          : selectedRuiRoNhanDienSection3,
    }))
  }, [selectedRuiRoNhanDienSection2, selectedRuiRoNhanDienSection3])

  useEffect(() => {}, [section])
  // Chạy khi dữ liệu thay đổi

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [rui_ro_phat_sinh, rui_ro_template] = await Promise.all([
          riskAriseStore.getRiskAriseList({ page: 0, pageSize: 10000 }),
          riskStore.getListTemplate(),
        ])
        setRuiRoNhanDienList([
          ...rui_ro_phat_sinh.data.data.map(item =>
            item.identification_risk.trim().replace(/\s+/g, ' ')
          ),
          ...rui_ro_template.data.data.map(item =>
            item.rui_ro_nhan_dien.trim().replace(/\s+/g, ' ')
          ),
        ])
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    getRiskUnitsByTypeList('DVPT')
    getRiskUnitsByTypeListNDDPV('NDDPV')
  }, [])

  useEffect(() => {
    getRiskUnitsByTypeList('DVPT')
    getRiskUnitsByTypeListNDDPV('NDDPV')
  }, [])

  const [depattData, setDepattData] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getDepartmentWithUsers('CPN7451091748209')
        setDepattData(response.data)
      } catch (error) {
        console.log(error)
        message.error(error.vi || 'Đã có lỗi xảy ra!')
      }
    }

    fetchData()
  }, [])

  const treeData = Array.isArray(riskUnitsV2)
    ? riskUnitsV2.map(item => ({
        title: item.name || '',
        value: item.code || '',
        key: item.code || '',
        disabled: true,
        children: Array.isArray(item.unit_users)
          ? item.unit_users.map(user => ({
              title:
                utils && utils.getNameInCapitalize
                  ? utils.getNameInCapitalize(user.full_name)
                  : user.full_name || '',
              value: user.user_code || '',
              key: user.user_code || '',
              position_name: user.position_name || '',
            }))
          : [],
      }))
    : []

  const treeData1 = dataRiskUnitsByType?.map(item => ({
    title: item.name,
    value: item.code,
    key: item.code,
    disabled: true,
    children: item.unit_users.map(user => ({
      title: user.full_name,
      value: user.user_code,
      key: user.user_code,
      position_name: user.position_name,
    })),
  }))
  const treeData2 = depattData?.map(item => ({
    title: item.name,
    value: item.code,
    key: item.code,
    disabled: true,
    children: item?.users?.map(user => ({
      title: utils.getNameInCapitalize(user.name_uppercase),
      value: user.user_code,
      key: user.user_code,
      position_name: user.position_name,
    })),
  }))

  const treeData3 = dataRiskUnitsByTypeNDDPV?.map(item => ({
    title: item.name,
    value: item.code,
    key: item.code,
    disabled: true,
    children: item?.unit_users?.map(user => ({
      title: user.full_name,
      value: user.user_code,
      key: user.user_code,
      position_name: user.position_name,
    })),
  }))

  const treeDataDp = departmentWithUserList.map(item => ({
    title: item.name,
    value: item.code,
    key: item.code,
    children: item.users.map(user => ({
      title: utils.getNameInCapitalize(user.name_uppercase),
      value: user.user_code,
      key: user.user_code,
    })),
  }))

  const combinedTreeData = [
    ...treeData,
    ...treeData1,
    ...treeData2,
    ...treeData3,
    ...treeDataDp,
  ]
  function removeDuplicates(data) {
    const seenTitles = new Set() // Để lưu các tiêu đề đã thấy
    const uniqueData = []

    for (const item of data) {
      if (!seenTitles.has(item.title)) {
        seenTitles.add(item.title)
        uniqueData.push(item)
      }
    }
    // Đệ quy để xử lý các phần tử con
    for (const item of uniqueData) {
      if (item.children && item.children.length > 0) {
        item.children = removeDuplicates(item.children) // Gọi đệ quy cho children
      }
    }
    return uniqueData
  }

  const finalTreeData = Array.from(
    new Set(combinedTreeData.map(JSON.stringify))
  ).map(JSON.parse)
  const [treeData_BPDX, setTreeData] = useState([])
  const [treeData_BP, setTreeDataBP] = useState([])
  const [treeData_LD, setTreeDataLD] = useState([])
  const [listChildren, setListChildren] = useState([])
  useEffect(() => {
    const updatedTreeData = treeData2?.concat(treeData1)
    setTreeData(updatedTreeData)
    const updatedTreeDataBP = treeData2?.concat(treeData)
    setTreeDataBP(updatedTreeDataBP)
    const updatedTreeDataLD = treeData2?.concat(treeData3)
    setTreeDataLD(updatedTreeDataLD)
  }, [riskUnitsV2, departmentWithUserList])

  const combinedData = treeData_BP.concat(treeData_BPDX)
  const uniqueData = combinedData.reduce((accumulator, current) => {
    // Kiểm tra nếu đã có phần tử với key và value tương tự trong accumulator
    const isDuplicate = accumulator.some(
      item => item.key === current.key && item.value === current.value
    )

    // Nếu không phải là trùng lặp, thêm vào accumulator
    if (!isDuplicate) {
      accumulator.push(current)
    }

    // Đối với phần tử con, xử lý tương tự
    if (current.children) {
      current.children = current.children.reduce(
        (childAccumulator, childCurrent) => {
          const isChildDuplicate = childAccumulator.some(
            childItem =>
              childItem.key === childCurrent.key &&
              childItem.value === childCurrent.value
          )
          if (!isChildDuplicate) {
            childAccumulator.push(childCurrent)
          }
          return childAccumulator
        },
        []
      )
    }

    return accumulator
  }, [])

  const [disabled, setDisabled] = useState(true)
  const [selectedValue, setSelectedValue] = useState(null)
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(true)
  const [isChecked, setIsChecked] = useState(reportDetail?.is_sign || false)
  const [treeSelectValue, setTreeSelectValue] = useState(null)

  useEffect(() => {
    // Check initial values and set selectedField accordingly
    if (editReport?.cqvp_code) {
      setSelectedField('cqvp_code')
    } else if (editReport?.dvpt_code) {
      setSelectedField('dvpt_code')
    } else if (editReport?.nddpv_code) {
      setSelectedField('nddpv_code')
    }
  }, [editReport])

  const handleSelectChange = (field, value) => {
    if (value) {
      setSelectedField(field)
    } else {
      setSelectedField(null)
    }
  }

  useEffect(() => {
    if (modalVisible) {
      setTimeout(() => {
        setIsRenderRichText(true)
      }, 600)
    } else {
      setIsRenderRichText(false)
    }
  }, [modalVisible])

  useEffect(() => {
    if (modalVisible) {
      getRiskUnits()
      getRiskUnitsV2('DVPT')
    }
  }, [modalVisible, getRiskUnits, getRiskUnitsV2])

  useEffect(() => {
    ;(async () => {
      try {
        await riskStore.getRiskUnitsV2('DVPT')
        await riskStore.getRiskUnits()
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      }
    })()
    return () => {}
  }, [])
  useEffect(() => {
    ;(async () => {
      await positionStore.getPositionList()
      await roleStore.getRoles()
      if (!companyList) {
        getCompanyList()
      }
    })()
  }, [])

  const [section2Content, setSection2Content] = useState(
    editReport?.section2 || ''
  )
  const [section3Content, setSection3Content] = useState(
    editReport?.section3 || ''
  )
  const handleEditorChange = (section, content) => {
    if (section === 'section2') {
      setSection2Content(content)
    } else if (section === 'section3') {
      setSection3Content(content)
    }
  }

  useEffect(() => {
    if (ruiRoNhanDien) {
      const currentEditorContent = SECTION2_REF.current?.editor.getData() || ''
      const currentLines = currentEditorContent
        .split(/<\/?p[^>]*>/)
        .filter(text => text.trim() !== '')
      const section2RiskData = ruiRoNhanDien.section2.map(item =>
        item.rui_ro_nhan_dien
          ? item.rui_ro_nhan_dien.replace(/\s+/g, ' ')
          : item.identification_risk.replace(/\s+/g, ' ')
      )
      const filteredEditorContent = currentLines.filter(
        line => !ruiRoNhanDienList.includes(line)
      )
      const uniqueParagraphs = [
        ...new Set([...filteredEditorContent, ...section2RiskData]),
      ]
        .map(item => `<p>${item}</p>`)
        .join('')
      SECTION2_REF.current?.editor.setData(uniqueParagraphs)
    }
  }, [ruiRoNhanDien?.section2, editReport])

  useEffect(() => {
    if (ruiRoNhanDien) {
      const currentEditorContent = SECTION3_REF.current?.editor.getData() || ''
      const currentLines = currentEditorContent
        .split(/<\/?p[^>]*>/)
        .filter(text => text.trim() !== '')
      const section3RiskData = ruiRoNhanDien.section3.map(item =>
        item.rui_ro_nhan_dien
          ? item.rui_ro_nhan_dien.replace(/\s+/g, ' ')
          : item.identification_risk.replace(/\s+/g, ' ')
      )
      const filteredEditorContent = currentLines.filter(
        line => !ruiRoNhanDienList.includes(line)
      )
      const uniqueParagraphs = [
        ...new Set([...filteredEditorContent, ...section3RiskData]),
      ]
        .map(item => `<p>${item}</p>`)
        .join('')
      SECTION3_REF.current?.editor.setData(uniqueParagraphs)
    }
  }, [ruiRoNhanDien?.section3, editReport])

  const [yearDetail, setYearDetail] = useState('')
  useEffect(() => {
    if (editReport) {
      const submitDate = moment(editReport.report_submit_date, 'DD-MM-YYYY')
      const startDate = moment(editReport.report_period_start, 'DD-MM-YYYY')
      const endDate = moment(editReport.report_period_end, 'DD-MM-YYYY')
      if (editReport.quarter) {
        const year = editReport.quarter.split('-')[1]
        setYearDetail(year)
      }
      form.setFieldsValue({
        title: editReport.title,
        dateRange: [startDate, endDate],
        report_submit_date: submitDate,
        dvpt_code: editReport.dvpt_code,
        nddpv_code: editReport.nddpv_code,
        cqvp_code: editReport.cqvp_code,
        risk_unit_code: editReport.risk_unit_code,
        risk_dependent_code: editReport.risk_dependent_code,
        section1: editReport.section1,
        section2: editReport.section2,
        section3: editReport.section3,
        section4: editReport.section4,
        truong_ban: editReport.sign_user,
        truong_ban__signed: editReport.is_sign,
        chuc_vu: editReport.position_sign,
        quarter: editReport.quarter,
      })
      setIsChecked(editReport.is_sign || false)
    }
  }, [editReport, form])

  const onFinish = async values => {
    if (submitting) return
    setSubmitting(true)
    const fields = [
      'risk_unit_code',
      'risk_dependent_code',
      'cqvp_code',
      'nddpv_code',
      'dvpt_code',
    ]
    const {
      dvpt_code,
      nddpv_code,
      cqvp_code,
      dateRange,
      report_submit_date,
    } = values
    const [startDate, endDate] = dateRange
    if (
      (!dvpt_code || dvpt_code.length === 0) &&
      (!nddpv_code || nddpv_code.length === 0) &&
      (!cqvp_code || cqvp_code.length === 0)
    ) {
      message.error('Vui lòng chọn một đơn vị', 1)
      setSubmitting(false)
      return
    }

    const section2 = JSON.stringify({
      data: ruiRoNhanDien.section2,
      other: SECTION2_REF.current.editor
        .getData()
        .split(/<\/?p[^>]*>/)
        .filter(item => item.trim() !== '' && !ruiRoNhanDienList.includes(item))
        .map(item => `<p>${item.trim()}</p>`)
        .join(''),
    })

    const section3 = JSON.stringify({
      data: ruiRoNhanDien.section3,
      other: SECTION3_REF.current.editor
        .getData()
        .split(/<\/?p[^>]*>/)
        .filter(item => item.trim() !== '' && !ruiRoNhanDienList.includes(item))
        .map(item => `<p>${item.trim()}</p>`)
        .join(''),
    })

    const submitData = {
      type: reportType,
      title: values.title,
      risk_unit_code: values.risk_unit_code,
      risk_dependent_code: values.risk_dependent_code,
      cqvp_code: values.cqvp_code,
      dvpt_code: values.dvpt_code,
      nddpv_code: values.nddpv_code,
      section1: SECTION1_REF.current.editor.getData(),
      section2: section2,
      section3: section3,
      section4: SECTION4_REF.current.editor.getData(),
      report_submit_date: report_submit_date.format('DD-MM-YYYY'),
      report_period_start: startDate.format('DD-MM-YYYY'),
      report_period_end: endDate.format('DD-MM-YYYY'),
      sign_user: values.truong_ban ? values.truong_ban : null,
      is_sign: isChecked,
      position_sign: values.chuc_vu,
      quarter: values.quarter,
    }

    loadingAnimationStore.showSpinner(true)
    updateRiskReport(reportDetail.code, submitData)
      .then(() => {
        handleCancelAdd()
        loadingAnimationStore.showSpinner(false)
        message.success('Cập nhật báo cáo thành công', 2)
        onRefresh()
      })
      .finally(() => {
        setSubmitting(false)
        loadingAnimationStore.showSpinner(false)
      })
  }


  const handleCancelAdd = useCallback(() => {
    onCancel()
  }, [onCancel])

  const validateUnits = (_, value) => {
    const riskUnitCode = form.getFieldValue('risk_unit_code')
    const riskDependentCode = form.getFieldValue('risk_dependent_code')

    if (!riskUnitCode && !riskDependentCode) {
      return Promise.reject(
        new Error(
          'Vui lòng chọn ít nhất một trong hai trường: Đơn vị hoặc Đơn vị phụ thuộc!'
        )
      )
    }
    return Promise.resolve()
  }

  const handleUnitChange = value => {
    setUnitValue(value)
    form.setFieldsValue({ risk_unit_code: value })
    form.validateFields(['risk_unit_code', 'risk_dependent_code'])
  }

  const handleDependentUnitChange = value => {
    setUnitV2Value(value)
    form.setFieldsValue({ risk_dependent_code: value })
    form.validateFields(['risk_unit_code', 'risk_dependent_code'])
  }

  const handleUnitClear = () => {
    setUnitValue([])
    form.setFieldsValue({ risk_unit_code: [] })
    form.validateFields(['risk_unit_code'])
  }

  const handleDependentUnitClear = () => {
    setUnitV2Value([])
    form.setFieldsValue({ risk_dependent_code: [] })
    form.validateFields(['risk_dependent_code'])
  }

  const [selectedValues, setSelectedValues] = useState(unitValue)
  const [selectedValuesV2, setselectedValuesV2] = useState(unitV2Value)

  const handleChange = values => {
    setSelectedValues(values)
  }

  const handleChangeV2 = values => {
    setselectedValuesV2(values)
  }

  const findNodeByValue = (nodes, value) => {
    for (const node of nodes) {
      if (node.value === value) {
        return node
      }
      if (node.children) {
        const foundNode = findNodeByValue(node.children, value)
        if (foundNode) {
          return foundNode
        }
      }
    }
    return null
  }

  const handleTreeChange = value => {
    const selectedNode = findNodeByValue(finalTreeData, value)
    if (selectedNode && selectedNode.children) {
      setValue(null)
      return
    }
    setValue(value)
  }
  const positions = [
    { value: 'Trưởng ban', label: 'Trưởng ban' },
    { value: 'Phó Trưởng ban', label: 'Phó Trưởng ban' },
    { value: 'Giám Đốc TT CNTT', label: 'Giám Đốc TT CNTT' },
    { value: 'Phó Giám đốc TT CNTT', label: 'Phó Giám Đốc TT CNTT' },
    { value: 'Giám Đốc chi nhánh', label: 'Giám Đốc chi nhánh' },
    { value: 'Phó Giám Đốc chi nhánh', label: 'Phó Giám Đốc chi nhánh' },
    { value: 'Giám Đốc công ty', label: 'Giám Đốc công ty' },
    { value: 'Phó Giám Đốc công ty', label: 'Phó Giám Đốc công ty' },
    { value: 'Chánh Văn phòng cơ quan', label: 'Chánh Văn phòng cơ quan' },
    {
      value: 'Phó chánh Văn phòng cơ quan',
      label: 'Phó chánh Văn phòng cơ quan',
    },
  ]
  useEffect(() => {
    setIsCheckboxDisabled(!treeSelectValue)
  }, [treeSelectValue])

  useEffect(() => {
    if (editReport) {
      const initialTreeSelectValue = !!editReport?.sign_user
      setIsChecked(editReport?.is_sign)
      setTreeSelectValue(initialTreeSelectValue)
      setIsCheckboxDisabled(!initialTreeSelectValue)
    }
  }, [editReport])

  const handleTreeSelectChange = value => {
    setSelectedValue(value)
    if (value) {
      setIsCheckboxDisabled(false)
      setTreeSelectValue(value)
    } else {
      setIsCheckboxDisabled(true)
      setIsChecked(false)
    }
  }

  const handleCheckboxChange = e => {
    setIsChecked(e.target.checked)
  }

  return (
    <>
      <Modal
        width={800}
        destroyOnClose={true}
        afterClose={() => {
          setIsRenderRichText(false)
        }}
        zIndex={500}
        style={{ top: 40 }}
        title={'Cập nhật báo cáo'}
        visible={modalVisible}
        scrollToFirstError
        maskClosable={false}
        // transitionName=""
        // maskTransitionName=""
        onCancel={handleCancelAdd}
        footer={null}>
        <Form
          form={form}
          layout={'vertical'}
          onFinish={onFinish}
          scrollToFirstError={true}>
          <div style={{ display: 'flex' }}>
            <h2>
              Loại:{' '}
              {reportType === REPORT_TYPE.PERIODICAL_REPORT
                ? 'Báo cáo định kỳ'
                : 'Báo cáo đột xuất'}
            </h2>
            <div style={{ marginLeft: '10px', width: '300px' }}>
              <Form.Item
                name={'quarter'}
                rules={[{ required: true, message: 'Vui lòng chọn quý!' }]}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}>
                <Select
                  placeholder={'Vui lòng chọn quý'}
                  style={{
                    width: 150,
                  }}
                  allowClear
                  options={[
                    {
                      value: `q1-${yearDetail}`,
                      label: `Quý I - ${yearDetail}`,
                    },
                    {
                      value: `q2-${yearDetail}`,
                      label: `Quý II - ${yearDetail}`,
                    },
                    {
                      value: `q3-${yearDetail}`,
                      label: `Quý III - ${yearDetail}`,
                    },
                    {
                      value: `q4-${yearDetail}`,
                      label: `Quý IV - ${yearDetail}`,
                    },
                  ]}
                />
              </Form.Item>
            </div>
          </div>
          <Form.Item
            name={'title'}
            label={'Tiêu đề:'}
            rules={[
              { required: true, message: 'Vui lòng nhập tiêu đề!' },
              { validator: validator.validateInputString },
            ]}>
            <Input placeholder={'Tiêu đề báo cáo'} />
          </Form.Item>
          <Form.Item
            name={'cqvp_code'}
            label={'Đơn vị thuộc Cơ quan Văn phòng Tổng công ty:'}>
            <Select
              allowClear
              showSearch
              onChange={value => handleSelectChange('cqvp_code', value)}
              value={selectedField === 'cqvp_code' ? undefined : null}
              disabled={selectedField && selectedField !== 'cqvp_code'}
              filterOption={handleFilterSelect}
              placeholder={'Chọn đơn vị'}
              tokenSeparators={[',']}>
              {departmentList?.map(unit => (
                <Option key={unit.code} name={'cqvp_code'} value={unit.code}>
                  {unit.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name={'dvpt_code'} label={'Đơn vị phụ thuộc VIMC:'}>
            <Select
              allowClear
              showSearch
              onChange={value => handleSelectChange('dvpt_code', value)}
              value={selectedField === 'dvpt_code' ? undefined : null}
              disabled={selectedField && selectedField !== 'dvpt_code'}
              filterOption={handleFilterSelect}
              placeholder={'Chọn đơn vị'}
              tokenSeparators={[',']}>
              {dataRiskUnitsByType.map(item => (
                <Option key={item.code} name={'dvpt_code'} value={item.code}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name={'nddpv_code'} label={'DNTV của VIMC:'}>
            <Select
              allowClear
              showSearch
              onChange={value => handleSelectChange('nddpv_code', value)}
              value={selectedField === 'nddpv_code' ? undefined : null}
              disabled={selectedField && selectedField !== 'nddpv_code'}
              filterOption={handleFilterSelect}
              placeholder={'Chọn đơn vị'}
              tokenSeparators={[',']}>
              {dataRiskUnitsByTypeNDDPV.map(item => (
                <Option key={item.code} name={'nddpv_code'} value={item.code}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div style={{ display: 'flex', gap: '70px' }}>
            <Form.Item
              name="report_submit_date"
              label="Ngày nộp báo cáo"
              style={{ width: '300px' }}
              rules={[
                { required: true, message: 'Vui lòng nhập ngày nộp báo cáo' },
              ]}>
              <DatePicker format={'DD-MM-YYYY'} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              name="dateRange"
              label="Kỳ báo cáo"
              style={{ width: '400px' }}
              rules={[{ required: true, message: 'Vui lòng nhập Kỳ báo cáo' }]}>
              <RangePicker format={'DD-MM-YYYY'} style={{ width: '100%' }} />
            </Form.Item>
          </div>
          {/* <Form.Item
            name={'risk_unit_code'}
            label={'Đơn vị:'}
            rules={[{ validator: validateUnits }]}>
            <Select
              allowClear
              showSearch
              filterOption={handleFilterSelect}
              defaultValue={unitValue}
              value={unitValue}
              tokenSeparators={[',']}
              mode="multiple"
              placeholder={'Đơn vị'}
              onChange={handleChange}
              onClear={handleUnitClear}>
              {riskUnits?.map(unit => (
                <Option key={unit.code} value={unit.code}>
                  {unit.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={'risk_dependent_code'}
            label={'Đơn vị phụ thuộc:'}
            rules={[{ validator: validateUnits }]}>
            <Select
              allowClear
              showSearch
              filterOption={handleFilterSelect}
              defaultValue={selectedValuesV2}
              value={unitV2Value}
              tokenSeparators={[',']}
              mode="multiple"
              placeholder={'Đơn vị phụ thuộc'}
              onChange={setselectedValuesV2}
              onClear={handleDependentUnitClear}>
              {Array.isArray(riskUnitsV2) &&
                riskUnitsV2.map(unit => (
                  <Option key={unit.code} value={unit.code}>
                    {unit.name}
                  </Option>
                ))}
            </Select>
          </Form.Item> */}
          <p style={{ marginTop: 16 }}>
            1. Báo cáo kết quả thực hiện công tác Quản trị rủi ro: (Áp dụng các
            nguyên tắc QTRR một cách có hệ thống trong tất cả các hoạt động của
            Văn phòng Tổng công ty/Ban chuyên môn/TTCNTT. Tuân thủ Chính sách,
            Quy trình quản lý rủi ro đã được phê duyệt và các quy định pháp luật
            khác)
          </p>
          <p>
            BIỆN PHÁP XỬ LÝ/TÌNH HÌNH KHẮC PHỤC/GIẢI PHÁP PHÒNG NGỪA/KIẾN NGHỊ
          </p>
          {!isRenderRichText && (
            <div style={{ height: 312, position: 'relative' }}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                tip="Đang tải dữ liệu..."
                isLoading={!isRenderRichText}
                backGround={'#ffffffc7'}
              />
            </div>
          )}
          {isRenderRichText && (
            <RichEditor
              EDITOR_REF={SECTION1_REF}
              placeholder={'Nhập nội dung...'}
              editorContent={editReport?.section1}
            />
          )}
          <p style={{ marginTop: 16 }}>
            2. Các rủi ro xảy ra trong kỳ báo cáo đã được xử lý{' '}
            <Button
              style={{ marginTop: 8, marginLeft: 8, color: blue }}
              onClick={() => {
                setIsVisibleRuiRoNhanDienTemplate(true)
                setSection('section2')
              }}>
              Chọn
            </Button>
          </p>
          {!isRenderRichText && (
            <div style={{ height: 312, position: 'relative' }}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                tip="Đang tải dữ liệu..."
                isLoading={!isRenderRichText}
                backGround={'#ffffffc7'}
              />
            </div>
          )}
          {isRenderRichText && (
            <RichEditor
              EDITOR_REF={SECTION2_REF}
              placeholder={'Nhập nội dung...'}
              editorContent={
                section2Data.data
                  .map(
                    item =>
                      `<p>${
                        item.rui_ro_nhan_dien
                          ? item.rui_ro_nhan_dien
                          : item.identification_risk
                      }</p>`
                  )
                  .join('') + section2Data.other
              }
              onChange={content => handleEditorChange('section2', content)}
            />
          )}
          <p style={{ marginTop: 16 }}>
            3. Các rủi ro xảy ra trong kỳ báo cáo chưa được xử lý{' '}
            <Button
              style={{ marginTop: 8, marginLeft: 8, color: blue }}
              onClick={() => {
                setIsVisibleRuiRoNhanDienTemplate(true)
                setSection('section3')
              }}>
              Chọn
            </Button>
          </p>
          {!isRenderRichText && (
            <div style={{ height: 312, position: 'relative' }}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                tip="Đang tải dữ liệu..."
                isLoading={!isRenderRichText}
                backGround={'#ffffffc7'}
              />
            </div>
          )}
          {isRenderRichText && (
            <RichEditor
              EDITOR_REF={SECTION3_REF}
              placeholder={'Nhập nội dung...'}
              editorContent={
                section3Data.data
                  .map(
                    item =>
                      `<p>${
                        item.rui_ro_nhan_dien
                          ? item.rui_ro_nhan_dien
                          : item.identification_risk
                      }</p>`
                  )
                  .join('') + section3Data.other
              }
              onChange={content => handleEditorChange('section3', content)}
            />
          )}
          <p style={{ marginTop: 16 }}>
            4. Nội dung phát hiện trong kỳ báo cáo: Có phát sinh rủi ro so với
            Nhận diện rủi ro đầu năm
          </p>
          {!isRenderRichText && (
            <div style={{ height: 312, position: 'relative' }}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                tip="Đang tải dữ liệu..."
                isLoading={!isRenderRichText}
                backGround={'#ffffffc7'}
              />
            </div>
          )}
          {isRenderRichText && (
            <RichEditor
              EDITOR_REF={SECTION4_REF}
              placeholder={'Nhập nội dung...'}
              editorContent={editReport?.section4}
            />
          )}
          <div style={{ marginTop: 16 }}></div>
          <Form.Item name="chuc_vu" label="Chức vụ">
            <Select
              placeholder="Chọn chức vụ"
              allowClear
              showSearch
              style={{ width: '100%' }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }>
              {positions?.map((item, index) => (
                <Option key={index} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name={'truong_ban'}>
            <TreeSelect
              treeData={uniqueData.filter(item => item.children.length > 0)}
              style={{ width: '100%' }}
              showArrow
              allowClear
              showSearch
              treeNodeFilterProp={'title'}
              filterTreeNode
              value={treeSelectValue}
              onChange={handleTreeSelectChange}
              treeDefaultExpandAll
              multiple={false}
              placeholder={'Chọn người'}
            />
          </Form.Item>

          <Form.Item name="truong_ban__signed" valuePropName="checked">
            <Space direction="vertical">
              <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                disabled={isCheckboxDisabled}>
                Xác nhận ký
              </Checkbox>
            </Space>
          </Form.Item>
          <FormButtonGroup>
            <Button type={'danger'} ghost onClick={handleCancelAdd}>
              Huỷ bỏ
            </Button>
            <Space size={'middle'}>
              <Button type={'primary'} htmlType={'submit'}>
                Cập nhật
              </Button>
            </Space>
          </FormButtonGroup>
        </Form>
      </Modal>
      <RuiRoNhanDienTemplate
        isVisible={isVisibleRuiRoNhanDienTemplate}
        handleCancelModal={() => {
          setIsVisibleRuiRoNhanDienTemplate(false)
        }}
        riskStore={riskStore}
        setRuiRoNhanDien={setRuiRoNhanDien}
        multiple={true}
        section={section}
        ruiRoNhanDien={ruiRoNhanDien}
        selectedRuiRoNhanDien={
          section === 'section2'
            ? selectedRuiRoNhanDienSection2
            : selectedRuiRoNhanDienSection3
        }
      />
    </>
  )
}
export default inject(
  'reportStore',
  'riskStore',
  'loadingAnimationStore',
  'companyStore',
  'positionStore',
  'roleStore',
  'departmentStore',
  'selectPeopleStore'
)(observer(ReportDetailUpdateModal))
